//@flow

import type {FeatureUsageResponse} from '../../entities/feature-usage';
import type {StoreFeature} from '../../entities/store-feature';
import {getFeatureUsageApi} from './api';

export async function getFeatureUsageService(
  feature: StoreFeature
): Promise<FeatureUsageResponse> {
  return getFeatureUsageApi({feature}).toPromise();
}
